import React, { useEffect } from "react";
import {
  Divider,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Paper,
} from "@material-ui/core";
import {
  Done as DoneIcon,
  BrokenImageOutlined as BrokenImageOutlinedIcon,
} from "@material-ui/icons";
import { useMainState } from "modules/app/contexts";

import { Container } from "./styles";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function StatusIcon({ credential }) {
  const { t } = useTranslation(["Credentials"]);

  let currentStatus = (
    <BrokenImageOutlinedIcon
      style={{ width: 250, height: 250, margin: "5px 5px 0" }}
      title={t(`status.${credential.sub_status}`)}
    />
  );

  if (credential.sub_status == "notLogged") {
    currentStatus = (
      <img
        style={{ width: 250, height: 250, margin: "5px 5px 0" }}
        src={credential.extra_info.qrcode}
        title={t(`status.${credential.sub_status}`)}
      />
    );
  } else if (
    ["chatsAvailable", "connected", "inChat"].includes(credential.sub_status)
  ) {
    currentStatus = (
      <DoneIcon
        style={{ width: 250, height: 250, margin: "5px 5px 0" }}
        title={t(`status.${credential.sub_status}`)}
      />
    );
  }

  return currentStatus;
}

function Credentials() {
  const history = useHistory();
  const { t } = useTranslation(["Credentials"]);
  const { user } = useMainState();
  const { credentials } = useMainState();

  useEffect(() => {
    if (user.role != "manager") {
      history.push("/app");
    }
  }, []);

  return (
    <Container>
      <Typography style={{ fontWeight: "bold", fontSize: 22 }}>
        {t(`title`)}
      </Typography>

      <Divider style={{ marginBottom: 30 }} />

      {credentials.map(
        (credential, key) =>
          credential.extra_info && (
            <Card key={key}>
              <CardHeader
                title="WhatsApp"
                subheader={t(`status.${credential.status}`)}
              />
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  Você deve se conectar ao WhatsApp para enviar e receber
                  mensagens.
                </Typography>
                <Paper style={{ width: 260, margin: "0 auto 10px" }}>
                  <StatusIcon credential={credential} />
                </Paper>
                <Typography variant="body2" color="textSecondary" component="p">
                  {t(`status.${credential.sub_status}`)}
                </Typography>
              </CardContent>
            </Card>
          )
      )}
    </Container>
  );
}

export default Credentials;
